/// Pure helpers for the per-segment photo strip UI.
///
/// The Photos section gets the image attachments (thumbs); the
/// Documents section gets PDFs and everything else (filename list).
/// Splitting in a pure helper means the rendering components stay
/// declarative and the partition is unit-testable without JSDOM.
///
/// `mime_type` is what the server stores; the BLOB itself is keyed
/// by `id`, so all the consumer needs to know is "is this an image?".

function isImageAttachment(att) {
  if (!att || typeof att.mime_type !== "string") return false;
  return att.mime_type.startsWith("image/");
}

function partitionAttachments(items) {
  const list = Array.isArray(items) ? items : [];
  const images = [];
  const docs = [];
  for (const a of list) {
    if (isImageAttachment(a)) images.push(a);
    else docs.push(a);
  }
  return { images, docs };
}

module.exports = { isImageAttachment, partitionAttachments };
